import styled from 'styled-components'

const StyledOrderSummary = styled.div`
  font-family: ${({ theme }) => theme.fonts.lexend};

  .item-list {
    border: 1px solid ${({ theme }) => theme.colors.gray[200]};
    border-radius: 3px 3px 0 0;
    border-bottom: 0;
  }

  .order-total {
    border: 1px solid ${({ theme }) => theme.colors.gray[200]};
    padding: 10px 1rem;
    border-radius: 0 0 3px 3px;
    background: ${({ theme }) => theme.colors.gray[100]};
    display: flex;
    align-items: center;
    justify-content: space-between;

    .total-label {
      font-size: 13px;
      letter-spacing: 0.06rem;
      color: ${({ theme }) => theme.colors.gray[500]};
    }

    .total-amount {
      font-weight: 400;
      color: ${({ theme }) => theme.colors.gray[700]};
      font-size: 14px;
    }
  }

  .discount-details {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem;
    color: ${({ theme }) => theme.colors.green[300]};

    .discount-description {
      font-size: 13px;
    }

    .total-discount {
      text-align: right;
      font-size: 20px;
    }
  }
`

export default StyledOrderSummary
